import useGetRewardNewspaper from './useGetRewardNewspaper'

export default useGetRewardNewspaper
